(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["move-baseline-socks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('move-socks-offer')) {
    customElements.define('move-socks-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const details = this.querySelector('details');
        const storageKey = 'move-baseline-socks-dismissed-v1';
        try { if (sessionStorage.getItem(storageKey) === 'true') details.open = false; } catch (_) {}
        details.addEventListener('toggle', () => {
          try { sessionStorage.setItem(storageKey, String(!details.open)); } catch (_) {}
        });
        this.querySelectorAll('[data-socks-color]').forEach(button => {
          button.addEventListener('click', () => {
            const id = button.dataset.socksColor;
            this.querySelectorAll('[data-socks-color]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
            this.querySelectorAll('[data-socks-panel]').forEach(panel => { panel.hidden = panel.dataset.socksPanel !== id; });
          });
        });
        this.querySelectorAll('select[name="id"]').forEach(select => {
          select.addEventListener('change', () => {
            select.form.querySelector('[type="submit"]').disabled = !select.value || select.selectedOptions[0].disabled;
          });
        });
        this.querySelector('[data-socks-dismiss]').addEventListener('click', () => {
          details.open = false;
          this.querySelector('summary').focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
